import { Link } from 'react-router-dom';
import { ctaData } from '@/mocks/homeData';

export default function CTASection() {
  return (
    <section className="relative w-full py-20 md:py-24 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20elegant%20abstract%20background%20with%20soft%20flowing%20gradients%20of%20rose%20gold%20and%20cream%20tones%2C%20delicate%20organic%20shapes%2C%20gentle%20light%20beams%2C%20dreamy%20atmospheric%20composition%2C%20emotional%20and%20inspiring%20mood%2C%20fine%20art%20style%20with%20soft%20textures&width=1800&height=600&seq=jiujiu-cta-01&orientation=landscape"
        alt="久久伊人 - 开启您的久久之旅"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-primary-700/85 via-primary-800/70 to-accent-700/80" />

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-background-50 mb-4">
          {ctaData.title}
        </h2>
        <p className="text-sm md:text-base text-background-50/85 max-w-md mx-auto mb-8">
          {ctaData.subtitle}
        </p>
        <Link
          to={ctaData.buttonLink}
          className="inline-flex items-center gap-2 px-8 py-3.5 rounded-md bg-background-50 text-primary-700 font-semibold text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-accent-500 hover:text-background-50"
        >
          {ctaData.buttonText}
          <i className="ri-heart-line" />
        </Link>
      </div>
    </section>
  );
}